import { For, createEffect, createSignal, on } from "solid-js";
import { spoken } from "../game/spoken";
import type { View } from "../game/view";

// One polite log for a screen reader, always there, so that what is put in it is said. It holds only the latest few lines: nothing else on the table is rebuilt for it.
export function SpokenLog(props: { view: () => View; assisted: boolean; said: string }) {
  const [lines, setLines] = createSignal<string[]>([]);
  const add = (more: string[]) => more.length > 0 && setLines((l) => [...l, ...more].slice(-6));
  createEffect(on(props.view, (v, prev) => prev && add(spoken(prev, v, props.assisted))));
  createEffect(on(() => props.said, (s) => s && add([s]), { defer: true }));
  return (
    <div class="sr-only" role="log" aria-live="polite" aria-relevant="additions">
      <For each={lines()}>{(l) => <p>{l}</p>}</For>
    </div>
  );
}
